import * as yup from "yup";

export const addInvestmentForm = yup.object().shape({
  "project-name": yup
    .string()
    .required("A project must be selected")
    .trim()
    .test({
      name: "valid-project-name",
      message: "Project name must have at least two alphanumeric characters",
      test: function (value) {
        if (typeof value !== "string" || value.trim() === "") {
          return this.createError({
            message: "Project name should be provided",
          });
        }
        const hasAtLeastTwoAlphanumeric = /[A-Za-z0-9].*[A-Za-z0-9]/.test(
          value,
        );
        if (!hasAtLeastTwoAlphanumeric) {
          return this.createError({
            message:
              "Project name should have at least two alphanumeric characters",
          });
        }

        return true;
      },
    }),
  quantity: yup
    .number()
    .typeError("The quantity needs to be a number")
    .positive("The quantity needs to be a positive number")
    .required("The quantity is needed and must be a number")
    .test({
      name: "valid-investment-quantity",
      message: "The quantity needs to be a positive number",
      test: function (value) {
        if (value === undefined || value === null) {
          return this.createError({
            message: "The quantity is needed",
          });
        }
        if (typeof value !== "number" || isNaN(value) || value <= 0) {
          return this.createError({
            message: "The quantity needs to be a positive number",
          });
        }
        return true;
      },
    }),
  unit: yup
    .string()
    .typeError("The unit of sale isn't set correctly.")
    .required("The unit of sale isn't set correctly.")
    .oneOf(
      ["Tree(s)", "Tonnes CO2", "m2", "m3 Kelp", "Biodiversity"],
      "The unit of sale isn't set correctly.",
    ),
  note: yup.string().trim(),
  notifyClient: yup.boolean().default(true),
});
